<head>
  <title>Dms Report</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb *ngIf="refreshbreadcrumb"></app-breadcrumb>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row ps-0">
  <div class="col-md-8">

    <!--Inventory search keys  -->
    <!--Inventory search keys  -->
    <div *ngIf="message.dmsReportButtonVal=='Activity Vs User'">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email"><b> Folder Path</b> :</label></div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              [(ngModel)]="dmsGroupFoldersFieldData.folderName"
              [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()">
          </div>
        </div>

        <div class="col-md-3">
          <div><label for="email" id="userName"><b> User Name</b>: </label></div>
          <div style="display: flex; align-items: center;">
            <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
              [(ngModel)]="oneQmsUsersFieldData.managerName" (ngModelChange)="onNgModelChangeForUser($event,'userName')"
              placeholder="Search">
            &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchManagerFunction()"
              (keydown.enter)="searchManagerFunction()"></span>
          </div>
        </div>

      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
      <div>
      </div>
    </div>
    <div *ngIf="message.dmsReportButtonVal=='Inventory'">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email" id="folder"><b> Folder Path</b> :</label></div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              [(ngModel)]="dmsGroupFoldersFieldData.folderName"
              [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()"
              (keydown.enter)="searchDocumentFunction()">
          </div>
        </div>
        <div class="col-md-3">
          <div><label for="email" id="documentTypes"><b>Document Type</b></label></div>
          <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
            (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search')"
            (keydown.enter)="focusSearch('document-type-search')">
            <input type="search" id="document-type-search" class="dropdownsearchstyle"
              [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
            <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
              [value]="item.valueExp" (onSelectionChange)="ondocumentTypeSelectnew($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-1" *ngIf="dmsGroupFoldersFieldData.folderPath=='Repository'">
          <label for="Physical"><b> Physical</b></label>
          <div style="bottom: 235px;">
            <input type="checkbox" style="zoom: 1.2;margin-top: 3px;" [checked]="physicalFolderLevel"
              (change)="showPhysicalFolderLevel($event)">
          </div>
        </div>
        <div class="col-md-2" *ngIf="dmsGroupFoldersFieldData.folderPath=='Repository'">
          <label for="Distributed"><b> Distributed</b></label>
          <div style="bottom: 235px;">
            <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="distributedFolderLevel"
              (change)="showDstributedFolderLevel($event)">
          </div>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
      <div>
      </div>
    </div>
    <div *ngIf="message.dmsReportButtonVal=='Master Index'">
      <div class="row">
        <div class="col-md-6">
          <div><label for="email" id="folderMasterAlert"><b> Folder Path</b> <span
                class="mandatory-symbol">*</span>:</label></div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              [(ngModel)]="dmsGroupFoldersFieldData.folderName"
              [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()"
              (ngModelChange)="onNgModelChange(dmsGroupFoldersFieldData.folderName,'folderMasterAlert')">
          </div>
        </div>
        <div class="col-md-6">
          <div><label for="email" id="documentType"><b>Document Type</b></label></div>
          <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
            (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search')"
            (keydown.enter)="focusSearch('document-type-search')">
            <input type="search" id="document-type-search5" class="dropdownsearchstyle"
              [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="newdocumentTypeSelection" (change)="toggleAllSelection('newDocumentType')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
              [value]="item.valueExp"> {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-12">
          <div class="row" style="margin-top: 42px;background-color: whitesmoke;">
            <div class="col-md-4">
              <label for="includeAmendments"><b>Include Amendments</b></label>
              <div style="bottom: 235px;">
                <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="includeAmendmentsFlg"
                  (change)="showIncludeAmendmentsFlg($event)">
              </div>
            </div>
            <div class="col-md-4">
              <label for="includeAmendments"><b>Include Associated Documents</b></label>
              <div style="bottom: 235px;">
                <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="associatedDocFlg"
                  (change)="showAssociatedDocFlg($event)">
              </div>
            </div>
            <div class="col-md-4">
              <label for="includeAmendments"><b>Include Belongs to Individual Documents</b></label>
              <div style="bottom: 235px;">
                <input type="checkbox" style="zoom: 1.2; margin-top: 3px;" [checked]="individualDocFlg"
                  (change)="showIndividualFlg($event)">
              </div>
            </div>
          </div>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
      <div>
      </div>
    </div>
    <div class="row" *ngIf="message.dmsReportButtonVal=='Milestone'">
      <div class="col-md-3">
        <div><label for="email" id="documentTypes2"><b>Document Type</b></label></div>
        <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
          (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search')"
          (keydown.enter)="focusSearch('document-type-search')">
          <input type="search" id="document-type-search4" class="dropdownsearchstyle"
            [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="newdocumentTypeSelection" (change)="toggleAllSelection('newDocumentType')">
              Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
            [value]="item.valueExp"> {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email" id="teaskView"><b> Document No</b>: </label></div>
        <div style="display: flex; align-items: center;">
          <input type="text" class="form-control" style="padding: 6px 20px;" [disabled]="true"
            [(ngModel)]="getSelectedTaskId" placeholder="Search">
          &nbsp; <span class="fa fa-search form-control-feedback" (click)="searchTaskVwFunction()"
            (keydown.enter)="searchTaskVwFunction()"></span>
        </div>
      </div>
      <div class="col-md-2">
        <label for="email" id="groupNameAlert"><b>Specify Interval</b></label>&nbsp;
        <div>
          <mat-slide-toggle color="primary" [(ngModel)]="specificIntervalVal" (change)="specificIntervalFun($event)">
            <span class="active-inActive-container" *ngIf="specificIntervalVal" style="color: green;">Yes</span>
            <span *ngIf="!specificIntervalVal" style="color: red;">No</span>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-3" *ngIf="specificIntervalVal">
        <div><label for="email" id="groupNameAlerts"><b>Date Range</b> : </label></div>
        <ng-multiselect-dropdown class="multiselect-container" [(ngModel)]="selectedDateRangeValue"
          [settings]="singleSelectDropdownSetting" [data]="dateRangeValueDropdown"
          (onSelect)="onDateRangeValueSelect($event)" [disabled]="true">
        </ng-multiselect-dropdown>
      </div>
      <div class="col-md-4" *ngIf="specificIntervalVal">
        <label for="email"><b>From Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="fromDate">
      </div>
      <div class="col-md-4" *ngIf="specificIntervalVal">
        <label for="email"><b>To Date</b> : </label>
        <input type="text" style="width: 80%;" class="form-control data-picker-continer" bsDatepicker
          [bsConfig]="datePickerConfiguration" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="toDate">
      </div>
      <div class="row" d-flex align-items-center>
        <br>
        <div class="col-sm-12 group-dropdown-align text-center">
          <div class="button-continer">
            <button mat-stroked-button class="addButton" (click)="genReport()">
              Generate
            </button>&nbsp;
            <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
              Reset
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="message.dmsReportButtonVal=='Distributed Folder Documents Report'">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email" id="documentNo"><b>Document No</b></label></div>
          <input type="text" class="form-control" style="font-size: 13px;" placeholder="Document No"
            [(ngModel)]="documentNo">
        </div>
        <div class="col-md-3">
          <div><label for="email" id="documentTypes1"><b>Document Type</b></label></div>
          <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
            (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search')"
            (keydown.enter)="focusSearch('document-type-search')">
            <input type="search" id="document-type-search2" class="dropdownsearchstyle"
              [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="newdocumentTypeSelection" (change)="toggleAllSelection('newDocumentType')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
              [value]="item.valueExp"> {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="message.dmsReportButtonVal=='Expiry Check'">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email" id="documentNos"><b>Document No</b></label></div>
          <input type="text" class="form-control" style="font-size: 13px;" placeholder="Document No"
            [(ngModel)]="documentNo">
        </div>
        <div class="col-md-3">
          <div><label for="email" id="documentType1"><b>Document Type</b></label></div>
          <mat-select matInput multiple placeholder="Select" #documentType [(ngModel)]="selectedDocumentType"
            (closed)="documentTypeSearchText=''" (click)="focusSearch('document-type-search')"
            (keydown.enter)="focusSearch('document-type-search')">
            <input type="search" id="document-type-search1" class="dropdownsearchstyle"
              [(ngModel)]="documentTypeSearchText" matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="newdocumentTypeSelection" (change)="toggleAllSelection('newDocumentType')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of documentTypeDropdown | multiAssessmentSearchPipe : documentTypeSearchText"
              [value]="item.valueExp"> {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
      <div>
      </div>
    </div>
    <div *ngIf="message.dmsReportButtonVal=='Folder'">
      <div class="row">
        <div class="col-md-3">
          <div><label for="email" id="folder1"><b> Folder Path</b> :</label></div>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              [(ngModel)]="dmsGroupFoldersFieldData.folderName"
              [disabled]="visibleDmsGroupFoldersReasonForUpdateField === true" (click)="searchDocumentFunction()">
          </div>
        </div>
      </div>
      &nbsp;&nbsp;
      <div class="col-sm-12 group-dropdown-align text-center">
        <div class="button-continer">
          <button mat-stroked-button class="addButton" (click)="genReport()">
            Generate
          </button>&nbsp;
          <button mat-stroked-button class="cancelButton" (click)="resetFunction()">
            Reset
          </button>
        </div>
      </div>
      <div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <h3 class="reports_title">Reports</h3>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Default'}" (click)="buttonClinkFun('Default')"
        (keydown.enter)="buttonClinkFun('Default')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/circle.png" width="16px" height="16px" alt="Default">
        </div>
        <p class="report_subtext">Default</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Inventory'}" (click)="buttonClinkFun('Inventory')"
        (keydown.enter)="buttonClinkFun('Inventory')">
        <div class="reports_block">
          <img src="../../assets/img/stock-keeping-unit.png" width="16px" height="16px" alt="Inventory">
        </div>
        <p class="report_subtext">Inventory</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Master Index'}"
        (click)="buttonClinkFun('Master Index')" (keydown.enter)="buttonClinkFun('Master Index')">
        <div class="reports_block">
          <img src="../../assets/img/analysis.png" width="16px" height="16px" alt="Master Index">
        </div>
        <p class="report_subtext">Master Index</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Expiry Check'}"
        (click)="buttonClinkFun('Expiry Check')" (keydown.enter)="buttonClinkFun('Expiry Check')">
        <div class="reports_block">
          <img src="../../assets/img/calendarwhite.png" width="16px" height="16px" alt="Expiry Check">
        </div>
        <p class="report_subtext">Expiry Check</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Distributed Folder Documents Report'}"
        (click)="buttonClinkFun('Distributed Folder Documents Report')"
        (keydown.enter)="buttonClinkFun('Distributed Folder Documents Report')">
        <div class="reports_block">
          <img src="../../assets/img/claim-form.png" width="16px" height="16px"
            alt="Distributed Folder Documents Report">
        </div>
        <p class="report_subtext">Distributed Folder Documents Report</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Folder'}" (click)="buttonClinkFun('Folder')"
        (keydown.enter)="buttonClinkFun('Folder')">
        <div class="reports_block">
          <img src="../../assets/img/folder (3).png" width="16px" height="16px" alt="Folder">
        </div>
        <p class="report_subtext">Folder</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Milestone'}" (click)="buttonClinkFun('Milestone')"
        (keydown.enter)="buttonClinkFun('Milestone')">
        <div class="reports_block">
          <img src="../../assets/img/DMS/milestone.svg" width="16px" height="16px" alt="Milestone">
        </div>
        <p class="report_subtext">Milestone</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Blinded'}" (click)="buttonClinkFun('Blinded')"
        (keydown.enter)="buttonClinkFun('Blinded')">
        <div class="reports_block">
          <img src="../../assets/img/hidden.png" width="16px" height="16px" alt="Blinded">
        </div>
        <p class="report_subtext">Blinded</p>
      </div>
    </div>
    <div class="d-flex justify-content-between mt-4">
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Unblinded'}" (click)="buttonClinkFun('Unblinded')"
        (keydown.enter)="buttonClinkFun('Unblinded')">
        <div class="reports_block">
          <img src="../../assets/img/DmsView.png" width="16px" height="16px" alt="Unblinded">
        </div>
        <p class="report_subtext">Unblinded</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Withdrawn'}" (click)="buttonClinkFun('Withdrawn')"
        (keydown.enter)="buttonClinkFun('Withdrawn')">
        <div class="reports_block">
          <img src="../../assets/img/withdrawWhite.png" width="16px" height="16px" alt="Withdrawn">
        </div>
        <p class="report_subtext">Withdrawn</p>
      </div>
      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Deleted'}" (click)="buttonClinkFun('Deleted')"
        (keydown.enter)="buttonClinkFun('Deleted')">
        <div class="reports_block">
          <img src="../../assets/img/DeleteWhite.png" width="16px" height="16px" alt="Deleted">
        </div>
        <p class="report_subtext">Deleted</p>
      </div>

      <div class="d-flex gap-2 align-items-center report"
        [ngClass]="{'active':this.message.dmsReportButtonVal === 'Activity Vs User'}"
        (click)="buttonClinkFun('Activity Vs User')" (keydown.enter)="buttonClinkFun('Activity Vs User')"
        style=" cursor: pointer;">
        <div class="reports_block">
          <img src="../../assets/img/DMS/cr_performance.svg" width="16px" height="16px" alt="Activity Vs User">
        </div>
        <p class="report_subtext">Activity Vs User</p>

      </div>
    </div>
  </div>
</div>
<hr>

<div class="table-container"
  *ngIf="showNoRecordFoundInventry && (message.dmsReportButtonVal=='Deleted' || message.dmsReportButtonVal=='Withdraw' || message.dmsReportButtonVal=='Unblinded' || message.dmsReportButtonVal=='Blinded')">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="row"
  *ngIf="tmsUserTrainingsRepVwDataForGrid.length>0 && (message.dmsReportButtonVal=='Deleted' || message.dmsReportButtonVal=='Withdrawn' || message.dmsReportButtonVal=='Unblinded' || message.dmsReportButtonVal=='Blinded')">
  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          </th>
          <th id="grid-header-container"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngIf="pagedItems.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width':'200px','max-width':'200px','overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" alt="">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                  <span class="ms-1" style="color:azure">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat )}}</span>
            <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span
              *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
              list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>

      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " id="dropdownBasic" ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>
<div class="table-container" *ngIf="showNoRecordFoundInventry && message.dmsReportButtonVal=='Activity Vs User'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="row" *ngIf="tmsUserTrainingsRepVwDataForGrid.length>0 && message.dmsReportButtonVal=='Activity Vs User'">
  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          </th>
          <th id="grid-header-container1"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngIf="pagedItems.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container2" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" alt="">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                  <span class="ms-1" style="color:azure">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat )}}</span>
            <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span
              *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
              list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>
<div class="row" *ngIf="tmsUserTrainingsRepVwDataForGrid.length>0 && message.dmsReportButtonVal=='Inventory'">
  <div class="table-container">
    <div class="row">
      <div class="col-6"></div>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center col-2"
        *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
          <path style="fill:'#FFFFFF'"
            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
        </svg>
        <span class="reload_text text-white">Settings</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">Excel Report</span>
      </div>
      <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
        (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
        <span class="reload_text text-white">PDF Report</span>
      </div>
    </div>&nbsp;&nbsp;
    <div class="table-container">
      <table style="height: 60vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
          </th>
          <th id="grid-header-container1"
            *ngFor="let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index;"
            [ngStyle]="{'min-width': oneQmsUsersDataForTable1Data.width}"
            class="sticky-dynamic-col1 dynamic-table-header-style">
            <div *ngIf="oneQmsUsersDataForTable1Data.fieldColumnarray != 'Prim Identifier'">
              <span>{{oneQmsUsersDataForTable1Data.fieldColumnarray}}</span>
              <div class="row-search-container">
                <input type="text" class="form-control" placeholder="Search"
                  (input)="applyFilter7(columnLists.columnsListarray[ix],$event,'s')">
              </div>
            </div>
          </th>
        </thead>
        <tr *ngIf="pagedItems.length === 0">
          <td class="row-data text-center" colspan="15">No records found</td>
        </tr>
        <tr *ngFor="let list of pagedItems  | searchFilter : searchValue; let idx = index;">
          <td style="min-width: 60px; text-align: center;"
            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
            <div style="display: flex;">
              <div [ngClass]="list.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div>
                <input type="checkbox" style="zoom: 1.2;" [checked]="childCheckBoxs"
                  (change)="dataGridChildCheckBoxChecked($event, list, idx)">
              </div>
            </div>
          </td>
          <td id="grid-row-container2" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
            'text-overflow': 'ellipsis',
            'white-space': 'nowrap'}" [ngClass]="{'hidden-column': key.columnsListarray === 'PRIM_IDENTIFIER'}">
            <span *ngIf="key.dataType=='CHECKBOX'">
              <div class="gridCheckBoxes">
                <img *ngIf="list[key.columnsListarray]" alt="" src="../../assets/img/accessSymbol.svg" width="20"
                  height="20">
                <img *ngIf="list[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg" width="20"
                  height="20" alt="">
              </div>
            </span>
            <span *ngIf="list[key.columnsListarray]=='htmlClobView'">
              <div class="download-button-continer btn-align" mat-dialog-actions>
                <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                  (click)="getClobData(list,key.columnsListarray)">
                  <img src="../../../assets/img/view.png" width="12px" height="12px" alt="download">
                  <span class="ms-1" style="color:azure">View</span>
                </button>
              </div>
            </span>
            <span
              *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list[key.columnsListarray] !='htmlClobView' && list[key.columnsListarray] !='fileIspresentsa' && list[key.columnsListarray] !='fileIsNotpresentsa' ">{{
              list[key.columnsListarray]}}</span>
            <span *ngIf="key.dataType=='DATE' && key.columnsListarray=='EFFECTIVE_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat )}}</span>
            <span *ngIf="key.dataType=='DATE'&& key.columnsListarray=='EXPIRATION_DATE'">{{ list[key.columnsListarray] |
              date : (appService.getOneQmsDateFormat)}}</span>
            <span
              *ngIf="key.dataType=='DATE'&& key.columnsListarray!='EFFECTIVE_DATE' && key.columnsListarray!='EXPIRATION_DATE'">{{
              list[key.columnsListarray] }}</span>
          </td>
        </tr>
      </table>
    </div>
    <div class="row border-top mt-1 width-cheat small paginationCell">
      <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>
      <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
        {{ showingRowsText }}
        1-{{ perPage }} of {{ collectionSize | number }}
        <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage,$event)" [disabled]="false"
          [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
          [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
        </ngb-pagination>
        <div ngbDropdown class="d-inline-block leftpadding">
          <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
            {{perPage}}
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </nav>
      <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
      </div>
    </div>
  </div>
</div>
<!--Milestone  grid -->
<div class="table-container"
  *ngIf=" showNoRecordFoundFolderDocuments  && message.dmsReportButtonVal=='Distributed Folder Documents Report'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="table-container"
  *ngIf="tableReportDataList.length>0 && message.dmsReportButtonVal=='Distributed Folder Documents Report'">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Type Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentTypeName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentNo', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Version</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('version', $event,'n')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Distributed From</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('distributedFrom', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Distributed To</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('distributedTo', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Effective Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('effectiveDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Expiration Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('expirationDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created By</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('createdByUser', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('createdOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated By</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('updatedByUser', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('updatedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.documentTypeName }}</td>
        <td class="row-data">{{ listOfUsersData.documentNo }}</td>
        <td class="row-data">{{ listOfUsersData.documentName }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.distributedFrom }}</td>
        <td class="row-data">{{ listOfUsersData.distributedTo }}</td>
        <td class="row-data">{{ listOfUsersData.effectiveDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.expirationDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Expiry Check -->
<div class="table-container" *ngIf=" showNoRecordFoundExpireheck  && message.dmsReportButtonVal=='Expiry Check'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="table-container" *ngIf="tableReportExpireCheckList.length>0 && message.dmsReportButtonVal=='Expiry Check'">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Expiry Status</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('expiryStatus', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Revised Before Expiry</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('revisedBeforeExpiry', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Type Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('documentTypeName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('documentNo', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('documentName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Version</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('version', $event,'n')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Status</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter5('status', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Effective Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('effectiveDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Expiration Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('expirationDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Folder Path</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('folderPath', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created By</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('createdBy', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('createdOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated By</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('updatedBy', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter5('updatedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems2.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems2; let idx = index;"
        [ngClass]="getColor(listOfUsersData.documentId)">
        <td class="row-data">{{ listOfUsersData.expiryStatus }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.revisedBeforeExpiry === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.revisedBeforeExpiry === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.documentTypeName }}</td>
        <td class="row-data">{{ listOfUsersData.documentNo }}</td>
        <td class="row-data">{{ listOfUsersData.documentName }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.effectiveDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.expirationDateStr }}</td>
        <td class="row-data">{{ listOfUsersData.folderPath }}</td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr }}</td>
      </tr>
    </table>
  </div>
  <div class="row border-top mt-1 width-cheat small paginationCell">
    <nav class="col-4 col-md-2 mt-2" aria-labelledby=" "></nav>

    <nav class="col-6 col-md-6 mt-2 pr-0 d-flex justify-content-end align-items-center" aria-labelledby=" ">
      {{ showingRowsText }}
      1-{{ perPage }} of {{ collectionSize | number }}
      <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage,$event)" [disabled]="false"
        [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
        [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
      </ngb-pagination>
      <div ngbDropdown class="d-inline-block leftpadding">
        <button class="btn btn-primary btn-sm mr-1 " ngbDropdownToggle>
          {{perPage}}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
          <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
          <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
          <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
        </div>
        per page
      </div>
    </nav>
    <div class="col-2 col-md-4 d-flex justify-content-end align-items-center">
    </div>
  </div>
</div>
<!-- folder -->
<div class="table-container" *ngIf="showNoRecordFoundMilestone  && message.dmsReportButtonVal=='Folder'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="table-container" *ngIf="tableReportDataList.length>0 && message.dmsReportButtonVal=='Folder'">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Folder Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('folderName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Folder Code</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('folderCode', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Is Distributed Folder</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('isDistributedFolder', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Type Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('documentTypeName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Folder Description</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('folderDescription', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Override Document No Format At Folder</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('overrideDocumentNoFormatAtFolder', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No Format</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('documentNoFormat', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No Regeneration</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('documentNoRegeneration', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No No. Of Digits</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('documentNoNoOfDigits', $event,'n')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Allow To Input Document No Manually</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('allowToInputDocumentNoManually', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Allow To Input Version Manually</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('allowToInputVersionManually', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Group List</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('groupList', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Status</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter3('status', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Folder Name Path</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('folderNamePath', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>All Parent Folder Status</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('allParentFolderStatus', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created By</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('createdByUser', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('createdOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Update Reason</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('updatedReason', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated By</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('updatedBy', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Updated On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter3('updatedOn', $event,'d')" />
          </div>
        </th>
        <th id="menu1" class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.folderName }}</td>
        <td class="row-data">{{ listOfUsersData.folderCode }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.isDistributedFolder === 'Y'" src="../../assets/img/accessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.isDistributedFolder === 'N'" src="../../assets/img/noAcessSymbol.svg" width="20"
              height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.documentTypeName }}</td>
        <td class="row-data">{{ listOfUsersData.folderDescription }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.overrideDocumentNoFormatAtFolder === 'Y'"
              src="../../assets/img/accessSymbol.svg" width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.overrideDocumentNoFormatAtFolder === 'N'"
              src="../../assets/img/noAcessSymbol.svg" width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.documentNoFormat }}</td>
        <td class="row-data">{{ listOfUsersData.documentNoRegeneration }}</td>
        <td class="row-data">{{ listOfUsersData.documentNoNoOfDigits }}</td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.allowToInputDocumentNoManually === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.allowToInputDocumentNoManually === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">
          <div class="icon-container">
            <img *ngIf="listOfUsersData.allowToInputVersionManually === 'Y'" src="../../assets/img/accessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
            <img *ngIf="listOfUsersData.allowToInputVersionManually === 'N'" src="../../assets/img/noAcessSymbol.svg"
              width="20" height="20" alt="Access granted symbol">
          </div>
        </td>
        <td class="row-data">{{ listOfUsersData.groupList }}</td>
        <td class="row-data">{{ listOfUsersData.status }}</td>
        <td class="row-data">{{ listOfUsersData.folderNamePath }}</td>
        <td class="row-data">{{ listOfUsersData.allParentFolderStatus }}</td>
        <td class="row-data">{{ listOfUsersData.createdByUser }}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.updateReason}}</td>
        <td class="row-data">{{ listOfUsersData.updatedByUser }}</td>
        <td class="row-data">{{ listOfUsersData.updatedOnStr}}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<!--Milestone  grid -->
<div class="table-container" *ngIf=" showNoRecordFoundMilestone  && message.dmsReportButtonVal=='Milestone'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="table-container" *ngIf="tableReportDataList.length>0 && message.dmsReportButtonVal=='Milestone'">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Type</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('taskType', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter4('taskId', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Sub Module</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('subModule', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Version</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('version', $event,'n')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Status</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search" (input)="applyFilter4('status', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Created On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('createdOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Completed On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('completedOn', $event,'d')" />
          </div>
        </th>

        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Review Requested On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('reviewRequestedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Review Completed On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('reviewCompletedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Approval Requested On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('approvalRequestedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Approval Completed On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('approvalCompletedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Sign off Requested On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('signoffRequestedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>sign off Completed On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('signoffCompletedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Published On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('publishedOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Withdrawn On</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('withdrawnOn', $event,'d')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.taskType }}</td>
        <td class="row-data">{{ listOfUsersData.taskId }}</td>
        <td class="row-data">{{ listOfUsersData.subModule }}</td>
        <td class="row-data">{{ listOfUsersData.version }}</td>
        <td class="row-data">{{ listOfUsersData.status}}</td>
        <td class="row-data">{{ listOfUsersData.createdOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.completedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.reviewRequestedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.reviewCompletedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.approvalRequestedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.approvalCompletedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.signoffRequestedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.signoffCompletedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.publishedOnStr}}</td>
        <td class="row-data">{{ listOfUsersData.withdrawnOnStr}}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<!--Master  Index -->
<div class="table-container" *ngIf="showNoRecordFoundMasterIndex  && message.dmsReportButtonVal=='Master Index'">
  <span style=" width: 100%; height: 220px;display: block; text-align: center; font-weight: bold; font-size: 24px;">
    <img src="../../assets/img/empty-box.png" alt="Group Intervals"
      style="width: 100px; height: 100px; margin-right: 10px;">
    <br> No record found
  </span>
</div>
<div class="table-container" *ngIf="tableReportDataList.length>0 && message.dmsReportButtonVal=='Master Index'">
  <div class="row">
    <div class="col-8"></div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Excel')" (keydown.enter)="openReportPopup('Excel')">
      <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">Excel Report</span>
    </div>
    <div class="col-2 addIconContiner d-flex gap-2 justify-content-center align-items-center"
      (click)="openReportPopup('Pdf')" (keydown.enter)="openReportPopup('Pdf')">
      <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
      <span class="reload_text text-white">PDF Report</span>
    </div>
  </div>&nbsp;&nbsp;
  <div class="table-container">
    <table style="height: 60vh;">
      <thead>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Type Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentTypeName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document No</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentNo', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Document Name</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('documentName', $event,'s')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Version</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('version', $event,'n')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Effective Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('effectiveDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-dynamic-col1 dynamic-table-header-style">
          <span>Expiration Date</span>
          <div class="row-search-container">
            <input type="text" class="form-control" placeholder="Search"
              (input)="applyFilter4('expirationDate', $event,'d')" />
          </div>
        </th>
        <th class="sticky-col first-col"></th>
      </thead>
      <tr *ngIf="pagedItems1.length === 0">
        <td class="row-data text-center" colspan="15">No records found</td>
      </tr>
      <tr class="data-row-container" *ngFor="let listOfUsersData of pagedItems1; let idx = index;">
        <td class="row-data">{{ listOfUsersData.documentTypeName}}</td>
        <td class="row-data">{{ listOfUsersData.documentNo}}</td>
        <td class="row-data">{{ listOfUsersData.documentName}}</td>
        <td class="row-data">{{ listOfUsersData.version}}</td>
        <td class="row-data">{{ listOfUsersData.effectiveDateStr}}</td>
        <td class="row-data">{{ listOfUsersData.expirationDateStr}}</td>
      </tr>
    </table>
  </div>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager.currentPage,$event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>
</div>
<!--end dy-->
<ng-template #searchFoldersPopup>
  <div class="popup-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSeachFoldersFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{popupDataTitle.title }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <app-folder-stucture [data]="'GROUPFOLDER'"
        (valueChange)="changeInFolderStructureChild($event)"></app-folder-stucture>
    </div>
    <div class="button-container">
      <div class="row">
        <h6 *ngIf="dmsGroupFoldersFieldData.folderName!=null">{{dmsGroupFoldersFieldData.folderName}}</h6>
      </div>
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="addFolderFunction()">
          <i class="fas fa-check"></i> Add
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelSeachFoldersFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<!--Excell & pdf -->
<ng-template #excelPdfPopup>
  <div class="page-loading-shade" *ngIf="appService.isProcessingRep">
    <app-custom-spinner *ngIf="appService.isProcessingRep"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;" class="align-center">
    <label for="email" style="font-size: medium; font-weight: bold;">Do you want to generate {{ popupDataTitle.title }}
      ?</label>
  </div>
  <div style="margin: 15px 15px;" class="align-center" *ngIf="!isForExcel">
    <label for="email" style="font-size: .7rem; font-weight: bold;">
      <span *ngIf="!manuallyPicked">This report will include the first 10 columns by default</span>
      <span *ngIf="manuallyPicked && maxCountReached">
        We recommend selecting a maximum of 10 columns for a cleaner and more readable PDF
      </span>
    </label>
  </div>
  <div class="row " *ngIf="!isForExcel" style="margin:10px 10px 7% 10px;">
    <div class="col-md-12" *ngIf="selectedColumns.length">
      <div><label for="email">Selected Column(s)</label></div>
      <textarea id="selectedValuesTextarea" class="input-filed-textarea" style="margin-top: 8px; cursor: not-allowed;"
        rows="4" cols="50" [disabled]="true" [(ngModel)]="selectedColumnsAsString"></textarea>
    </div>
    <div class="row" [ngClass]="selectedColumns.length ? 'mt-3' : '' ">
      <div class="col-md-6">
        <label for="radio">PDF Page Size</label>
        <mat-radio-group [(ngModel)]="excelPdf.pdfPageSize">
          <mat-radio-button *ngFor="let data of pdfPageSizes"
            [value]="data.codelistCode">{{data.codelistName}}</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="col-md-6" style="margin-top: 1.5%;">
        <label for="toggle">Pick Columns Manually?</label>&nbsp;
        <mat-slide-toggle color="primary" (change)="onCheckboxChange($event)" [(ngModel)]="manuallyPicked" id="toggle">
          <ng-container *ngIf="manuallyPicked; else no">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #no>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Report Logo</label>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
            (closed)="pdfDetailSearchText=''" (click)="focusSearch('focus-Logo-search')"
            (keydown.enter)="focusSearch('focus-Logo-search')">
            <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
              matInput placeholder="search">
            <mat-option [value]="null" class="unselectStyle"
              (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
            <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
        </div>
        <div class="col-sm-8">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter" (closed)="pdfDetailSearchText=''"
            (click)="focusSearch('focus-Logo-search')" (keydown.enter)="focusSearch('focus-Logo-search')">

            <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
              (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row justify-content-md-center">
        <div class="col-sm-4">
          <label for="email">Is Save Report?</label>
        </div>
        <div class="col-sm-8">
          <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
            <ng-container *ngIf="isSaveReport; else noisSaveReport">
              <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
            </ng-container>
            <ng-template #noisSaveReport>
              <span style="color: red;">No</span>
            </ng-template>
          </mat-slide-toggle>
        </div>
      </div>
      <div class="row justify-content-md-center" *ngIf="isSaveReport">
        <div class="col-sm-4">
          <label for="email">Report Name</label>
        </div>
        <div class="col-sm-8">
          <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
        </div>
      </div>
    </div>

    <div class="row mt-3" *ngIf="manuallyPicked">
      <div class="col-md-12">
        <div><label for="email">Select Column(s)</label><span class="mandatory-symbol">*</span></div>
        <mat-select matInput multiple placeholder="Select" #pdf id="execl-pdf" [(ngModel)]="selectedColumns"
          (closed)="pdfSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle" [(ngModel)]="pdfSearchText"
            matInput placeholder="search">
          <div class="select-all">
            <mat-checkbox [(ngModel)]="pdfSelection" (change)="toggleAllSelection('pdf')"> Select All</mat-checkbox>
          </div>
          <mat-option *ngFor="let item of excelPdf.dropDown | multiAssessmentSearchPipe : pdfSearchText"
            [value]="item.valueExp" (onSelectionChange)="onColumnSelect($event,item)">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" style="margin-top: 3%;" mat-dialog-actions>
    <button *ngIf="isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Excel')">
      <i class="fa fa-file-excel-o"></i> Generate
    </button>
    <button *ngIf="!isForExcel" mat-stroked-button class="addButton" (click)="generateReport('Pdf')">
      <i class="fa fa-file-pdf-o"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #searchTaskVW>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelAllTaskVwFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div id="filed-container" class="form-continer">
    <table class="search-manager-table-container">
      <th style="min-width: 80px; text-align: center;">
        <div style="display: flex;">
          <div>
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div style="margin-left: 5px;"></div>
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Document No</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('taskId', $event)" />
        </div>
      </th>
      <th class="sticky-dynamic-col1 dynamic-table-header-style">
        <span>Task Details</span>
        <div class="row-search-container">
          <input type="text" class="form-control" placeholder="Search" (input)="applyFilter6('taskDetails', $event)" />
        </div>
      </th>
      <tr class="data-row-container" *ngFor="let listOfUsersVwDetails of getTaskDetailsObj1; let idx = index;"
        [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
        <td style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input type="checkbox" style="zoom: 1.2;" [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                (change)="searchTaskVwChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
            </div>
          </div>
        </td>
        <td class="row-data">{{ listOfUsersVwDetails.taskId }}</td>
        <td class="row-data">{{ listOfUsersVwDetails.taskDetails }}</td>
      </tr>
    </table>
  </div>
  <div class="row">
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="addTaskVwGridDataFunction()">
        <i class="fas fa-check"></i> Add
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelAllTaskVwFunction()">
        <i class="fa fa-repeat"></i> cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #searchManager>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchManagerFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer">
    <div class="row">
      <div class="col-md-3">
        <div><label for="email ">User Name</label></div>
        <input class="search-filed-continers uppercase" type="text" [(ngModel)]="searchByUserName">
        <div id="searchbyUserName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
        <div id="firstName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
        <div id="lastName-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-3">
        <div><label for="email">Email Address</label></div>
        <input class="input-filed-continers" type="email" [(ngModel)]="searchByemailAddress">
      </div>
      <div class="col-md-3">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" id="focus-group-search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onDesignationCodeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onDesignationCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-3">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode" (closed)="groupSearchText=''"
          (click)="focusSearch('focus-group-search')" (keydown.enter)="focusSearch('focus-group-search')">
          <input type="search" class="dropdownsearchstyle" [(ngModel)]="groupSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onDepartmentCodeSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : groupSearchText"
            (onSelectionChange)="onDepartmentCodeSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchManagerGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" (click)="resetSearchManagerGridDataFunction()">
          <i class="fa fa-repeat"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="showUserSearchGrid">
      <table class="search-manager-table-container">
        <th style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div>
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
            </div>
          </div>
        </th>
        <th> <span>User Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>First Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Last Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>User Full Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Designation</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Department</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>EmailAddress</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Contact Number</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Manager Name</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Ad User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Factory User</span> <span class="fa-solid fa-filter"></span> </th>
        <th> <span>Is Active</span> <span class="fa-solid fa-filter"></span> </th>
        <th class="sticky-col first-col"></th>
        <tr class="data-row-container"
          *ngFor="let listOfUsersVwDetails of getOneQmsUsersVwDetailsTableData; let idx = index;"
          [class.highlightRow]="listOfUsersVwDetails.searchManagerChildCheckBoxs == true">
          <td style="min-width: 80px; text-align: center;">
            <div style="display: flex;">
              <div [ngClass]="listOfUsersVwDetails.searchManagerChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;">
                <input type="checkbox" style="zoom: 1.2;" [checked]="listOfUsersVwDetails.searchManagerChildCheckBoxs"
                  (change)="searchManagerChildCheckBoxChecked($event, listOfUsersVwDetails, idx)">
              </div>
            </div>
          </td>
          <td class="row-data">{{ listOfUsersVwDetails.userName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.firstName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.lastName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.userFullName }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.designation }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.department }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.emailAddress }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.contactNumber }}</td>
          <td class="row-data">{{ listOfUsersVwDetails.managerName }}</td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isAdUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isFactoryUser"> </td>
          <td class="row-data" style="text-align: center; zoom: 1.2;"> <input class="activeCheckbox-container"
              type="checkbox" [(ngModel)]="listOfUsersVwDetails.isActive"> </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions *ngIf="showUserSearchGrid">
    <button mat-stroked-button class="addButton" (click)="addManagerNameFunction()">
      <i class="fas fa-check"></i> Add
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelSearchManagerFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<app-editor #clobViewPopup></app-editor>

<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>